import React from "react";
import { useNavigate } from "react-router-dom";
import AxiosInstance from "../axios/AxiosInstance";
import {
  Home,
  Briefcase,
  ShoppingCart,
  Users,
  UserCheck,
  FileText,
  Library,
  Repeat,
  UserCircle,
  LogOut,
  Building,
  Bell,
  TrendingUp,
  Activity,
  BarChart3,
  ArrowUpRight,
  ArrowDownRight,
  Clock,
  CheckCircle2,
  AlertCircle,
} from "lucide-react";
import { useState, useEffect, useRef } from "react";
import { Badge } from "../components/reusableComponents/Badge";
import { Card, CardContent } from "../ui/Card";
import { motion } from "framer-motion";

export default function DashboardPage() {
  const navigate = useNavigate();
  const [nombreFacturesImpayees, setNombreFacturesImpayees] = useState(0);
  const [taches, setTaches] = useState(0);
  const [commandes, setCommandes] = useState(0);
  const [clients, setClients] = useState(0);
  const [candidats, setCandidats] = useState(0);
  const [caMensuel, setCaMensuel] = useState({});
  const [activeMissions, setActiveMissions] = useState(0);
  const [loading, setLoading] = useState(true);



  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const [caRes, missionsRes, tauxRes] = await Promise.all([
        AxiosInstance.get("facture/CA-mois"),
        AxiosInstance.get("pld-contract/active-missions"),
        AxiosInstance.get("pld-contract/taux-conversion"),
      ]);

      setLoading(false);

      console.log(caRes);
      setCaMensuel(caRes.data[0]);

      console.log(missionsRes);
      setActiveMissions(missionsRes.data);

      console.log(tauxRes);
      // setTaux supprimé car non utilisé dans le nouveau design
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  const CompterFactureImpaye = () => {
    AxiosInstance.get("facture/freelance/countNonSoldee")
      .then((res) => {
        setNombreFacturesImpayees(res.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };
  const CompterCandidats = () => {
    AxiosInstance.get("tempworker-candidate/freelance/tempworker-count")
      .then((res) => {
        setCandidats(res.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const CompterCommandes = () => {
    AxiosInstance.get("order/freelance/count")
      .then((res) => {
        setCommandes(res.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const Comptertaches = () => {
    AxiosInstance.get("task/todo-count")
      .then((res) => {
        setTaches(res.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const CompterClients = () => {
    AxiosInstance.get("client/freelance-count")
      .then((res) => {
        setClients(res.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };
  useEffect(() => {
    CompterFactureImpaye();
    CompterClients();
    CompterCommandes();
    CompterCandidats();
    Comptertaches();
  }, []);

  return (
    <div className="w-full min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
      <div className="w-full p-8">
        {/* Header Section */}
        <motion.div
          className="mb-8"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-4xl font-bold text-slate-900 mb-2">
                Bonjour {localStorage.getItem("firstname")} 👋
              </h1>
              <p className="text-lg text-slate-600">
                Voici un aperçu de votre activité aujourd'hui
              </p>
            </div>
            
          </div>
        </motion.div>
        {/* Métriques Principales */}
        <motion.div
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          {/* CA Mensuel */}
          <motion.div
            className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 hover:shadow-md transition-shadow duration-300"
            whileHover={{ y: -2 }}
          >
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center space-x-3">
                <div className="p-2 bg-emerald-100 rounded-lg">
                  <TrendingUp className="w-5 h-5 text-emerald-600" />
                </div>
                <div>
                  <p className="text-sm font-medium text-slate-600">CA Mensuel</p>
                  <p className="text-xs text-slate-500">Ce mois</p>
                </div>
              </div>
              {(caMensuel.currentMonthTotal ?? 0) - (caMensuel.previousMonthTotal ?? 0) > 0 ? (
                <ArrowUpRight className="w-4 h-4 text-emerald-500" />
              ) : (
                <ArrowDownRight className="w-4 h-4 text-red-500" />
              )}
            </div>
            <div className="space-y-1">
              <p className="text-2xl font-bold text-slate-900">
                {loading ? (
                  <div className="w-8 h-8 border-2 border-slate-300 border-t-emerald-500 rounded-full animate-spin"></div>
                ) : (
                  `${(caMensuel.currentMonthTotal ?? 0).toFixed(2)}€`
                )}
              </p>
              <p className="text-xs text-slate-500">
                {((caMensuel.currentMonthTotal ?? 0) - (caMensuel.previousMonthTotal ?? 0)) >= 0 ? '+' : ''}
                {((caMensuel.currentMonthTotal ?? 0) - (caMensuel.previousMonthTotal ?? 0)).toFixed(2)}€ vs mois dernier
              </p>
            </div>
          </motion.div>
          {/* Factures Impayées */}
          <motion.div
            className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 hover:shadow-md transition-shadow duration-300"
            whileHover={{ y: -2 }}
          >
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center space-x-3">
                <div className="p-2 bg-amber-100 rounded-lg">
                  <AlertCircle className="w-5 h-5 text-amber-600" />
                </div>
                <div>
                  <p className="text-sm font-medium text-slate-600">Factures</p>
                  <p className="text-xs text-slate-500">Impayées</p>
                </div>
              </div>
              <Clock className="w-4 h-4 text-amber-500" />
            </div>
            <div className="space-y-1">
              <p className="text-2xl font-bold text-slate-900">{nombreFacturesImpayees}</p>
              <p className="text-xs text-slate-500">En attente de paiement</p>
            </div>
          </motion.div>

          {/* Clients Actifs */}
          <motion.div
            className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 hover:shadow-md transition-shadow duration-300"
            whileHover={{ y: -2 }}
          >
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center space-x-3">
                <div className="p-2 bg-blue-100 rounded-lg">
                  <Users className="w-5 h-5 text-blue-600" />
                </div>
                <div>
                  <p className="text-sm font-medium text-slate-600">Clients</p>
                  <p className="text-xs text-slate-500">Total</p>
                </div>
              </div>
              <Activity className="w-4 h-4 text-blue-500" />
            </div>
            <div className="space-y-1">
              <p className="text-2xl font-bold text-slate-900">{clients}</p>
              <p className="text-xs text-slate-500">Clients enregistrés</p>
            </div>
          </motion.div>

          {/* Commandes en Cours */}
          <motion.div
            className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 hover:shadow-md transition-shadow duration-300"
            whileHover={{ y: -2 }}
          >
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center space-x-3">
                <div className="p-2 bg-purple-100 rounded-lg">
                  <BarChart3 className="w-5 h-5 text-purple-600" />
                </div>
                <div>
                  <p className="text-sm font-medium text-slate-600">Commandes</p>
                  <p className="text-xs text-slate-500">Actives</p>
                </div>
              </div>
              <CheckCircle2 className="w-4 h-4 text-purple-500" />
            </div>
            <div className="space-y-1">
              <p className="text-2xl font-bold text-slate-900">{commandes}</p>
              <p className="text-xs text-slate-500">En cours de traitement</p>
            </div>
          </motion.div>
        </motion.div>
        {/* Actions Rapides */}
        <motion.div
          className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          {/* Section Gauche - Actions Principales */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6">
            <h3 className="text-lg font-semibold text-slate-900 mb-6 flex items-center">
              <Activity className="w-5 h-5 mr-2 text-slate-600" />
              Actions Rapides
            </h3>
            <div className="grid grid-cols-2 gap-4">
              {[
                { icon: FileText, label: "Nouvelle Facture", href: "/facture", color: "bg-blue-50 hover:bg-blue-100 text-blue-700" },
                { icon: Users, label: "Ajouter Client", href: "/clients", color: "bg-emerald-50 hover:bg-emerald-100 text-emerald-700" },
                { icon: UserCheck, label: "Candidats", href: "/candidatsPage", color: "bg-purple-50 hover:bg-purple-100 text-purple-700" },
                { icon: Briefcase, label: "Commandes", href: "/commandesPage", color: "bg-amber-50 hover:bg-amber-100 text-amber-700" },
              ].map((action, index) => (
                <motion.button
                  key={index}
                  onClick={() => navigate(action.href)}
                  className={`p-4 rounded-lg transition-all duration-200 ${action.color} group`}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  <action.icon className="w-6 h-6 mb-2 mx-auto" />
                  <p className="text-sm font-medium text-center">{action.label}</p>
                </motion.button>
              ))}
            </div>
          </div>

          {/* Section Droite - Statistiques Détaillées */}
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6">
            <h3 className="text-lg font-semibold text-slate-900 mb-6 flex items-center">
              <BarChart3 className="w-5 h-5 mr-2 text-slate-600" />
              Aperçu Détaillé
            </h3>
            <div className="space-y-4">
              <div className="flex items-center justify-between p-3 bg-slate-50 rounded-lg">
                <div className="flex items-center space-x-3">
                  <div className="w-2 h-2 bg-emerald-500 rounded-full"></div>
                  <span className="text-sm font-medium text-slate-700">Candidats</span>
                </div>
                <span className="text-sm font-bold text-slate-900">{candidats}</span>
              </div>
              <div className="flex items-center justify-between p-3 bg-slate-50 rounded-lg">
                <div className="flex items-center space-x-3">
                  <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                  <span className="text-sm font-medium text-slate-700">Tâches</span>
                </div>
                <span className="text-sm font-bold text-slate-900">{taches}</span>
              </div>
              <div className="flex items-center justify-between p-3 bg-slate-50 rounded-lg">
                <div className="flex items-center space-x-3">
                  <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
                  <span className="text-sm font-medium text-slate-700">Missions Actives</span>
                </div>
                <span className="text-sm font-bold text-slate-900">{activeMissions}</span>
              </div>
            </div>
          </div>
        </motion.div>
        {/* Section Navigation Rapide */}
        <motion.div
          className="bg-white rounded-xl shadow-sm border border-slate-200 p-6"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.6 }}
        >
          <h3 className="text-lg font-semibold text-slate-900 mb-6 flex items-center">
            <Home className="w-5 h-5 mr-2 text-slate-600" />
            Navigation Rapide
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
            {[
              { icon: Briefcase, label: "Tâches", href: "/gestionDesTaches", count: taches },
              { icon: Library, label: "Bibliothèque", href: "/bibliotheque", count: null },
              { icon: Building, label: "Mon Compte", href: "/monCompte", count: null },
              { icon: FileText, label: "Contrats", href: "/contrats", count: null },
              { icon: Repeat, label: "Annonces", href: "/annonces", count: null },
              { icon: Bell, label: "Notifications", href: "#", count: 3 },
            ].map((item, index) => (
              <motion.button
                key={index}
                onClick={() => item.href !== "#" && navigate(item.href)}
                className="relative p-4 bg-slate-50 hover:bg-slate-100 rounded-lg transition-all duration-200 group"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                <item.icon className="w-6 h-6 mx-auto mb-2 text-slate-600 group-hover:text-slate-900" />
                <p className="text-xs font-medium text-slate-700 group-hover:text-slate-900">{item.label}</p>
                {item.count && (
                  <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
                    {item.count}
                  </span>
                )}
              </motion.button>
            ))}
          </div>
        </motion.div>
      </div>
    </div>
  );
}
